<mat-nav-list *ngIf="(dataService.company$ | async)" class="nav-list">
  <span class="noMessages"
        *ngIf="messages?.length == 0">{{ "label_no_messages" | translate }}
  </span>
  <div class="readAll"
        *ngIf="messages?.length > 0 && unread > 0">
    <button mat-button
            color="primary"
            (click)="readAllMessages()">
      Ler Todas
    </button>

  </div>
  <mat-list-item *ngFor="let message of messages"
                  (click)="openMessage(message)">
    <div class="d-flex py-1 align-items-center">
      <mat-icon *ngIf="!message.read"
                mat-list-icon>markunread</mat-icon>
      <mat-icon *ngIf="message.read"
                mat-list-icon>drafts</mat-icon>
      <div class="message-data">
        <h4 *ngIf="message.ro && message.ro.code"
            mat-line>
          <span *ngIf="message.type == messageTypes.authorized.id">
            @if (message.ro.codeSystem) {
              {{ "NOTIFICATION.RO_AUTHORIZED_AND_TRANSFORMED" | translate : { budgetCode: message.ro.budgetCode, codeSystem: message.ro.codeSystem } }}
            } @else {
              {{ "NOTIFICATION.RO_AUTHORIZED" | translate : { budgetCode: message.ro.budgetCode, codeSystem: message.ro.codeSystem } }}
            }
          </span>
          <span *ngIf="message.type == messageTypes.rejected.id">
            {{ "NOTIFICATION.RO_REJECTED" | translate : { budgetCode: message.ro.budgetCode } }}
          </span>
          <span *ngIf="message.type == messageTypes.evaluated.id">
            {{ "NOTIFICATION.RO_EVALUATED" | translate : { budgetCode: message.ro.budgetCode } }}
          </span>
        </h4>
        <h4 *ngIf="message.ro && !message.ro.code"
            mat-line>
          <span *ngIf="message.type == messageTypes.authorized.id">
            {{ "NOTIFICATION.RO_AUTHORIZED_NOT_INTEGRATED" | translate }}
          </span>
          <span *ngIf="message.type == messageTypes.rejected.id">
            {{ "NOTIFICATION.RO_REJECTED_NOT_INTEGRATED" | translate }}
          </span>
          <span *ngIf="message.type == messageTypes.evaluated.id">
            {{ "NOTIFICATION.RO_EVALUATED_NOT_INTEGRATED" | translate }}
          </span>
        </h4>
        <p mat-line class="m-0">
          {{ message.createdAt | date }}
        </p>
      </div>
    </div>
  </mat-list-item>
</mat-nav-list>
